import script from "./PdfCalculationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfCalculationCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__